import React from 'react';

import TripSearch from 'components/TripSearch';
import { SearchParams, SearchParamsHistory } from 'components/TripSearch/models';

interface Props {
  show: boolean;
  onClose: () => void;
  onSearch: (params: SearchParams | SearchParamsHistory) => void;
  params?: SearchParams | SearchParamsHistory;
  withItineraryProps: boolean;
}

const TripSearchContainer = ({ show, onClose, onSearch, params, withItineraryProps }: Props) => (
  <TripSearch
    show={show}
    onClose={onClose}
    onSearch={onSearch}
    isLoading={false}
    defaultParams={params}
    withItineraryProps={withItineraryProps}
  />
);

TripSearchContainer.defaultProps = {
  withItineraryProps: false,
};

export default TripSearchContainer;
